import React from "react";

const Icon = (props) => {
  if (props.icon === "wordpress") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="70"
        height="70"
        viewBox="0 0 70 70"
        className="skill-icon"
      >
        <path
          id="wordpress-brands"
          d="M9.675,24.875,24,64.109A30.031,30.031,0,0,1,9.675,24.875ZM57.363,35.587a15.833,15.833,0,0,0-2.47-8.284c-1.524-2.47-2.95-4.573-2.95-7.042a5.2,5.2,0,0,1,5.038-5.335c.127,0,.254.014.4.028A30.021,30.021,0,0,0,12,20.6c.706.028,1.369.042,1.933.042,3.133,0,8-.381,8-.381a1.239,1.239,0,0,1,.2,2.47s-1.623.183-3.429.282L29.645,55.528l6.577-19.7L31.55,23.012c-1.623-.1-3.147-.282-3.147-.282a1.239,1.239,0,0,1,.183-2.47s4.954.381,7.9.381c3.133,0,8-.381,8-.381a1.239,1.239,0,0,1,.2,2.47s-1.623.183-3.429.282L52.113,55.288,55.1,45.282c1.27-4.149,2.258-7.127,2.258-9.7ZM37.619,39.722l-9,26.179a29.916,29.916,0,0,0,18.446-.48,2.249,2.249,0,0,1-.212-.409ZM63.446,22.687a23.392,23.392,0,0,1,.2,3.091,28.206,28.206,0,0,1-2.286,10.754L52.183,63.05A30.054,30.054,0,0,0,63.446,22.687ZM72.1,37.1a35,35,0,1,1-35-35A35.039,35.039,0,0,1,72.1,37.1Zm-1.609,0A33.391,33.391,0,1,0,37.1,70.488,33.431,33.431,0,0,0,70.488,37.1Z"
          transform="translate(-2.097 -2.097)"
        />
      </svg>
    );
  } else if (props.icon === "html") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="70"
        viewBox="0 0 60 70"
      >
        <path
          id="html5-brands"
          d="M0,9.286,5.453,71.129l24.469,8.156,24.625-8.156L60,9.286ZM48.156,29.27H19.438l.641,7.719H47.516L45.391,60.176,30.094,64.4v.047h-.172L14.5,60.176l-.937-11.844h7.453l.547,5.953,8.359,2.266,8.391-2.266.937-9.719H13.172l-2-22.75H48.844Z"
          transform="translate(0 -9.286)"
        />
      </svg>
    );
  } else if (props.icon === "css") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="70"
        viewBox="0 0 60 70"
      >
        <path
          id="css3-alt-brands"
          d="M0,9.286,5.453,71.129,30,79.286l24.547-8.156L60,9.286Zm48.922,12.5-.75,7.391-18.016,7.7-.047.016H47.531l-2,22.906L30.188,64.286,14.75,59.723l-1-11.547h7.641l.5,5.984,8.219,2.078,8.547-2.406.578-9.625L13.25,44.129v-.016l-.031.016L12.656,36.9l17.516-7.3,1.016-.422h-19.2l-.906-7.391Z"
          transform="translate(0 -9.286)"
        />
      </svg>
    );
  } else if (props.icon === "bootstrap") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="70"
        height="70"
        viewBox="0 0 70 70"
      >
        <path
          id="bootstrap-brands"
          d="M45.672,53.025c0,6.627-6.206,6.473-6.863,6.473H26.17V46.734H38.809C45.459,46.734,45.672,51.719,45.672,53.025ZM37.836,41.6c.1,0,6.006.156,6.006-5.673,0-2.425-.548-5.6-6.006-5.6H26.17V41.6ZM70,20.953V67.619A11.7,11.7,0,0,1,58.333,79.286H11.667A11.7,11.7,0,0,1,0,67.619V20.953A11.7,11.7,0,0,1,11.667,9.286H58.333A11.7,11.7,0,0,1,70,20.953Zm-17.18,33c0-3.37-1.039-9.108-7.664-10.523v-.114a8.952,8.952,0,0,0,5.834-8.694c0-1.094.313-10.122-12.125-10.122H19.022V65.331c20.036,0,21.855.262,25.563-.892C46.8,63.748,52.82,61.629,52.82,53.951Z"
          transform="translate(0 -9.286)"
        />
      </svg>
    );
  } else if (props.icon === "js") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="70"
        height="70"
        viewBox="0 0 70 70"
      >
        <path
          id="js-square-brands"
          d="M62.5,9.286H7.5a7.5,7.5,0,0,0-7.5,7.5v55a7.5,7.5,0,0,0,7.5,7.5h55a7.5,7.5,0,0,0,7.5-7.5v-55A7.5,7.5,0,0,0,62.5,9.286ZM38.094,63.879c0,6.812-4,9.922-9.828,9.922-5.266,0-8.312-2.719-9.875-6.016l5.359-3.234c1.031,1.828,1.969,3.375,4.234,3.375,2.156,0,3.531-.844,3.531-4.141V41.426h6.578ZM53.656,73.8c-6.109,0-10.062-2.906-11.984-6.719l5.359-3.094c1.406,2.3,3.25,4,6.484,4,2.719,0,4.469-1.359,4.469-3.25,0-2.25-1.781-3.047-4.8-4.375l-1.641-.7c-4.75-2.016-7.891-4.563-7.891-9.922,0-4.938,3.766-8.687,9.625-8.687,4.188,0,7.187,1.453,9.344,5.266L57.5,49.6c-1.125-2.016-2.344-2.812-4.234-2.812A2.855,2.855,0,0,0,50.125,49.6c0,1.969,1.219,2.766,4.047,4l1.641.7c5.594,2.391,8.734,4.844,8.734,10.344,0,5.906-4.656,9.156-10.891,9.156Z"
          transform="translate(0 -9.286)"
        />
      </svg>
    );
  } else if (props.icon === "react") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="79.996"
        height="70"
        viewBox="0 0 79.996 70"
      >
        <path
          id="react-brands"
          d="M65.34,54.7q-1.266-.422-2.531-.8c.141-.578.266-1.156.391-1.734,1.922-9.312.656-16.8-3.609-19.265-4.109-2.359-10.812.094-17.593,6-.672.578-1.328,1.187-1.953,1.8-.422-.406-.859-.812-1.3-1.2-7.109-6.312-14.234-8.968-18.5-6.484-4.094,2.375-5.312,9.421-3.594,18.233.172.875.359,1.734.578,2.609-1,.281-1.984.594-2.906.922C5.984,57.665,0,62.228,0,66.946c0,4.875,6.375,9.765,15.046,12.734.7.234,1.406.469,2.125.672-.234.937-.437,1.859-.625,2.812-1.641,8.671-.359,15.546,3.734,17.905,4.219,2.437,11.312-.062,18.218-6.109.547-.484,1.094-.984,1.641-1.516.687.672,1.406,1.312,2.125,1.937,6.687,5.75,13.3,8.078,17.374,5.718,4.219-2.437,5.593-9.828,3.812-18.827q-.211-1.031-.469-2.109c.5-.141.984-.3,1.469-.453C73.465,76.727,80,71.9,80,66.946,80,62.212,73.84,57.619,65.34,54.7ZM44.2,41.432c5.812-5.062,11.234-7.046,13.7-5.625,2.64,1.516,3.656,7.64,2,15.687-.109.531-.219,1.047-.359,1.562A79.987,79.987,0,0,0,49.029,51.4a78.942,78.942,0,0,0-6.656-8.3C42.982,42.526,43.576,41.979,44.2,41.432ZM26.124,75.055c.8,1.359,1.609,2.719,2.469,4.047a70.745,70.745,0,0,1-7.25-1.172,72.984,72.984,0,0,1,2.547-6.953c.719,1.375,1.453,2.734,2.234,4.078Zm-4.734-18.8c2.25-.5,4.64-.906,7.125-1.219-.828,1.3-1.641,2.625-2.406,3.969-.766,1.328-1.516,2.687-2.219,4.062-.984-2.328-1.812-4.609-2.5-6.812Zm4.281,10.765c1.031-2.156,2.156-4.265,3.344-6.343s2.469-4.094,3.812-6.078c2.344-.172,4.734-.266,7.171-.266s4.843.094,7.172.266q1.992,2.953,3.8,6.047t3.39,6.312q-1.57,3.234-3.375,6.375c-1.187,2.078-2.453,4.094-3.781,6.093-2.328.172-4.75.25-7.2.25s-4.828-.078-7.125-.219q-2.039-2.976-3.844-6.093c-1.2-2.078-2.312-4.187-3.359-6.343Zm28.217,8c.8-1.375,1.547-2.765,2.281-4.172a72.529,72.529,0,0,1,2.64,6.922,68.632,68.632,0,0,1-7.343,1.25C52.31,77.711,53.107,76.368,53.888,75.024Zm2.25-11.952c-.734-1.375-1.484-2.75-2.265-4.094q-1.148-1.992-2.39-3.937a71.9,71.9,0,0,1,7.171,1.25A69.146,69.146,0,0,1,56.138,63.071ZM40.029,45.494c1.641,1.781,4.625,5.593,4.625,5.593s-6.2-.141-9.3,0C36.889,49.072,38.467,47.2,40.029,45.494ZM21.905,35.917c2.625-1.531,8.453.656,14.593,6.093.391.344.781.719,1.187,1.094a79.376,79.376,0,0,0-6.7,8.3,82.361,82.361,0,0,0-10.5,1.625c-.2-.8-.375-1.609-.547-2.422-1.469-7.562-.5-13.265,1.969-14.687ZM18.077,77.1c-.656-.187-1.3-.391-1.937-.609A31.866,31.866,0,0,1,6.3,71.618a7.011,7.011,0,0,1-2.937-4.672c0-2.859,4.937-6.515,12.062-9,.891-.312,1.8-.594,2.7-.859a83.079,83.079,0,0,0,3.828,9.937A85.406,85.406,0,0,0,18.077,77.1ZM36.295,92.414a28.6,28.6,0,0,1-8.812,5.515,6.915,6.915,0,0,1-5.515.2c-2.484-1.437-3.515-6.953-2.109-14.374.172-.875.359-1.75.578-2.609A78.164,78.164,0,0,0,31.045,82.68a82.454,82.454,0,0,0,6.75,8.343C37.295,91.507,36.795,91.976,36.295,92.414Zm3.828-3.8c-1.594-1.719-3.187-3.625-4.734-5.672,1.5.062,3.047.094,4.609.094,1.609,0,3.187-.031,4.75-.109A67.385,67.385,0,0,1,40.123,88.617ZM60.544,93.3a6.944,6.944,0,0,1-2.578,4.89c-2.484,1.437-7.781-.437-13.5-5.343-.656-.562-1.312-1.172-1.984-1.8a77.292,77.292,0,0,0,6.593-8.375,77.022,77.022,0,0,0,10.656-1.641c.156.641.3,1.281.422,1.906A28.482,28.482,0,0,1,60.544,93.3Zm2.844-16.8c-.437.141-.875.281-1.328.406a79.372,79.372,0,0,0-3.984-9.968A78.973,78.973,0,0,0,61.9,57.119c.812.234,1.594.484,2.344.734,7.281,2.5,12.39,6.218,12.39,9.062C76.637,69.977,71.184,73.93,63.387,76.508ZM40,74.165a7.156,7.156,0,1,0-7.156-7.156A7.155,7.155,0,0,0,40,74.165Z"
          transform="translate(0 -32.012)"
        />
      </svg>
    );
  } else if (props.icon === "frontend") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="57.52"
        height="40.74"
        viewBox="0 0 97.976 69.4"
      >
        <g id="frontend" transform="translate(0 -74.666)">
          <g id="Group_2" data-name="Group 2" transform="translate(0 74.666)">
            <path
              id="Path_14"
              data-name="Path 14"
              d="M81.647,135.9a8.128,8.128,0,0,0,8.124-8.165l.041-44.906a8.162,8.162,0,0,0-8.165-8.165H16.329a8.162,8.162,0,0,0-8.165,8.165v44.906a8.162,8.162,0,0,0,8.165,8.165H0a8.162,8.162,0,0,0,8.165,8.165H89.812a8.162,8.162,0,0,0,8.165-8.165ZM16.329,82.831H81.647v44.906H16.329Zm32.659,57.153A4.082,4.082,0,1,1,53.07,135.9,4.094,4.094,0,0,1,48.988,139.984Z"
              transform="translate(0 -74.666)"
              fill="#edc559"
            />
          </g>
        </g>
      </svg>
    );
  } else if (props.icon === "wp-alt") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="40.74"
        height="40.74"
      >
        <path
          fill="#edc559"
          d="M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
        ></path>
      </svg>
    );
  } else if (props.icon === "coach") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="43.484"
        height="40.74"
        viewBox="0 0 43.484 40.74"
      >
        <g id="coach" transform="translate(0 -0.09)">
          <path
            id="Path_15"
            data-name="Path 15"
            d="M168.477,308.817a3.024,3.024,0,1,1-3.024-3.024A3.024,3.024,0,0,1,168.477,308.817Zm0,0"
            transform="translate(-147.716 -278.03)"
            fill="#edc559"
          />
          <path
            id="Path_16"
            data-name="Path 16"
            d="M147.7,367.205a.567.567,0,0,0-.465.223,2.374,2.374,0,0,1-3.8,0,.568.568,0,0,0-.465-.225,2.779,2.779,0,0,0-2.8,2.756v4.323a.546.546,0,0,0,.6.518H149.9a.512.512,0,0,0,.557-.518v-4.323a2.745,2.745,0,0,0-2.757-2.756Zm0,0"
            transform="translate(-127.568 -333.973)"
            fill="#edc559"
          />
          <path
            id="Path_17"
            data-name="Path 17"
            d="M283.157,308.817a3.024,3.024,0,1,1-3.024-3.024A3.024,3.024,0,0,1,283.157,308.817Zm0,0"
            transform="translate(-252.008 -278.03)"
            fill="#edc559"
          />
          <path
            id="Path_18"
            data-name="Path 18"
            d="M255.172,369.961v4.323a.52.52,0,0,0,.566.518h9.135a.539.539,0,0,0,.588-.518v-4.323a2.772,2.772,0,0,0-2.788-2.756.567.567,0,0,0-.465.224,2.374,2.374,0,0,1-3.8,0,.566.566,0,0,0-.465-.225,2.752,2.752,0,0,0-2.767,2.756Zm0,0"
            transform="translate(-232.228 -333.973)"
            fill="#edc559"
          />
          <path
            id="Path_19"
            data-name="Path 19"
            d="M397.833,308.817a3.024,3.024,0,1,1-3.024-3.024A3.024,3.024,0,0,1,397.833,308.817Zm0,0"
            transform="translate(-356.417 -278.03)"
            fill="#edc559"
          />
          <path
            id="Path_20"
            data-name="Path 20"
            d="M376.737,367.205a.567.567,0,0,0-.465.223,2.331,2.331,0,0,1-.5.5,2.36,2.36,0,0,1-3.3-.5.569.569,0,0,0-.465-.227,2.809,2.809,0,0,0-2.832,2.756v4.323a.578.578,0,0,0,.631.518h9.135a.485.485,0,0,0,.523-.518v-4.323a2.717,2.717,0,0,0-2.724-2.756Zm0,0"
            transform="translate(-335.978 -333.973)"
            fill="#edc559"
          />
          <path
            id="Path_21"
            data-name="Path 21"
            d="M49.72,6.449a2.553,2.553,0,0,0,2.548-2.557V2.638a2.548,2.548,0,0,0-5.1,0V3.892A2.552,2.552,0,0,0,49.72,6.449Zm0,0"
            transform="translate(-42.636)"
            fill="#edc559"
          />
          <path
            id="Path_22"
            data-name="Path 22"
            d="M43.7,237.872l.5-16.665H36.871l.5,16.669a1.3,1.3,0,0,0,2.6-.032V223.687a.577.577,0,0,1,1.154,0v14.157a1.285,1.285,0,1,0,2.57.028Zm0,0"
            transform="translate(-33.325 -202.014)"
            fill="#edc559"
          />
          <path
            id="Path_23"
            data-name="Path 23"
            d="M.017,95.242v9.633a1.065,1.065,0,0,0,.335.781,1.109,1.109,0,0,0,.812.3h.015a1.126,1.126,0,0,0,1.146-1.132v-6.4a.577.577,0,1,1,1.154,0v3.891c0,.029,0,.039,0,.069l.028,1.072h7.4l-.026-.7V98.426a.577.577,0,1,1,1.154,0v3.889c0,.04.011.082.009.124l-.009.335v2.1a1.154,1.154,0,1,0,2.308,0V95.242c0-.019.024-.038.026-.058A2.68,2.68,0,0,0,12,92.235a2.559,2.559,0,0,0-.268-.027H10.307L7.6,94.765c-.011.011-.024.027-.036.036a.547.547,0,0,1-.046.038,1.041,1.041,0,0,1-.1.054l-.055.017a.5.5,0,0,1-.052.014.484.484,0,0,1-.057.006.515.515,0,0,1-.053,0,1.21,1.21,0,0,1-.11-.011c-.018,0-.036-.01-.054-.015S7,94.9,6.98,94.89a.569.569,0,0,1-.052-.027c-.016-.009-.032-.017-.048-.027s-.032-.025-.047-.039-.024-.029-.035-.039L4.191,92.207H2.674A2.689,2.689,0,0,0,0,94.9c0,.09,0,.189.011.279,0,.019.006.043.006.063Zm0,0"
            transform="translate(0 -83.917)"
            fill="#edc559"
          />
          <path
            id="Path_24"
            data-name="Path 24"
            d="M260.441,213.45a.574.574,0,0,1,.081-.075l-.035.028-5.606,4.995a.577.577,0,1,0,.767.861l5.223-4.653-.384-.342A.577.577,0,0,1,260.441,213.45Zm0,0"
            transform="translate(-231.621 -193.977)"
            fill="#edc559"
          />
          <path
            id="Path_25"
            data-name="Path 25"
            d="M324.626,219.642a.577.577,0,0,0,.384-1.007l-5.606-5,0,0a.583.583,0,0,1,.051.05.577.577,0,0,1-.047.814l-.384.342,5.223,4.653A.574.574,0,0,0,324.626,219.642Zm0,0"
            transform="translate(-290.128 -194.214)"
            fill="#edc559"
          />
          <path
            id="Path_26"
            data-name="Path 26"
            d="M223.769,63.073V49.207h-22.6V63.073A1.445,1.445,0,0,0,202.65,64.5h19.708a1.388,1.388,0,0,0,1.411-1.423Zm-19.408-9.731h12.4a.577.577,0,0,1,0,1.154h-12.4a.577.577,0,1,1,0-1.154Zm16.347,6.443H204.361a.577.577,0,1,1,0-1.154h16.347a.577.577,0,0,1,0,1.154Zm0-2.6H204.361a.577.577,0,1,1,0-1.154h16.347a.577.577,0,0,1,0,1.154Zm0,0"
            transform="translate(-184.132 -44.394)"
            fill="#edc559"
          />
          <path
            id="Path_27"
            data-name="Path 27"
            d="M183.172,1.207h26.155V4.669H183.172Zm0,0"
            transform="translate(-167.863 -1.01)"
            fill="#edc559"
          />
        </g>
      </svg>
    );
  } else {
    return "";
  }
};

export default Icon;
